import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useMemo } from 'react';
import classNames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles, 'Divider');
const Divider = _ref => {
  let {
    classes: classesProp,
    overrides: overridesProp,
    className: classNameProp,
    ...props
  } = _ref;
  const classes = useClasses(useStyles, classesProp);
  const override = getOverrides(overridesProp, Divider.overrides);
  const rootProps = useMemo(() => ({
    ...props,
    className: classNames(classes.root, classNameProp)
  }), [classNameProp, classes.root, props]);
  return /*#__PURE__*/React.createElement("div", _extends({}, rootProps, override.root));
};
export default /*#__PURE__*/memo(Divider);